import { render } from "./FacilitySettingsDashboardPage.vue?vue&type=template&id=0e2f156c"
import script from "./FacilitySettingsDashboardPage.vue?vue&type=script&lang=js"
export * from "./FacilitySettingsDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__